import {Button} from '@chakra-ui/react';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import ImageUI from 'ui/ImageUI';

interface IProps {
  phoneNumber: string;
  t: (term: TranslationKeys) => string;
  innerTitle: string;
}

export const CallBtn: FC<IProps> = ({phoneNumber, innerTitle}) => {
  return (
    <Button
      as="a"
      href={`tel:${phoneNumber}`}
      variant="outline"
      leftIcon={<ImageUI src="/icons/phone.svg" alt="Phone" />}
    >
      {innerTitle}
    </Button>
  );
};
